import { Image, Pressable, View, Text, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import colors from '../theme';

interface SectionHeaderProps {
  title: string;
  actionText?: string;
  onAction?: () => void;
  titleColor?: string;
}

const iconStar = require('../../assets/icon-star.png');

export default function SectionHeader({ title, actionText, onAction, titleColor }: SectionHeaderProps) {
  return (
    <View style={styles.container}>
      <View style={styles.titleRow}>
        <View style={styles.starBadge}>
          <Image source={iconStar} style={styles.starIcon} resizeMode="contain" />
        </View>
        <Text style={[styles.title, titleColor ? { color: titleColor } : null]}>{title}</Text>
      </View>
      {actionText ? (
        <Pressable style={styles.actionButton} onPress={onAction} disabled={!onAction} hitSlop={10}>
          <Text style={styles.action}>{actionText}</Text>
          <Ionicons name="chevron-forward" size={13} color={colors.button} />
        </Pressable>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  title: {
    color: colors.textPrimary,
    fontSize: 18,
    fontWeight: '900',
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    flex: 1,
  },
  starBadge: {
    width: 26,
    height: 26,
    alignItems: 'center',
    justifyContent: 'center',
  },
  starIcon: {
    width: 26,
    height: 26,
  },
  actionButton: {
    minHeight: 28,
    borderRadius: 14,
    backgroundColor: colors.accentSoft,
    paddingHorizontal: 10,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 2,
  },
  action: {
    color: colors.button,
    fontSize: 14,
    fontWeight: '800',
  },
});
